<template>
  <div class="data-loading">
    <div
      class="loading text-white position-absolute d-flex flex-column align-items-center justify-content-center"
    >
      <b-spinner class="spinner"></b-spinner>
      <div class="loading-text mt-3">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    loadingText() {
      const isLoading = this.$store.getters['env/isLoading'];
      if (typeof isLoading === 'string') {
        return this.$t(isLoading);
      }
      return this.$t('載入中');
    },
  },
};
</script>

<style lang="scss" scoped>
.data-loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1050;
  cursor: progress;
}
.loading {
  width: 130px;
  height: 130px;
  border-radius: 10px;
  background: $grayscale-30;
  z-index: 1050;
  top: calc(50vh - 65px);
  top: calc(50dvh - 65px);
  left: calc(50vw - 65px);
  left: calc(50dvw - 65px);
  .spinner {
    width: 48px;
    height: 48px;
  }
}
</style>
